import { useState } from "react";
import { toast } from "sonner";
import { fileService } from "@/services/ServiceRegistry";
import { useUpdateRoomCategory } from "@/hooks/useRoomCategories";
import { CreateRoomCategoryFormData } from "../../utils/categorySchema";
import { UpdateRoomCategoryRequest } from "@/types/roomCategory";

export const useCategoryUpdate = (id: string, hotelId: string) => {
  const updateRoomCategoryMutation = useUpdateRoomCategory(id, hotelId);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleRoomCategoryUpdate = async (
    data: Omit<CreateRoomCategoryFormData, "customFeatures">,
    selectedPhotoFile: File | null
  ) => {
    try {
      setIsLoading(true);
      const { price, photoId, ...categoryData } = data;

      let uploadedPhotoId = photoId;

      if (selectedPhotoFile) {
        try {
          uploadedPhotoId =
            await fileService.uploadFileWithPresignedUrl(selectedPhotoFile);
        } catch (uploadError) {
          console.error("Failed to upload photo:", uploadError);
          toast.error("Photo upload failed");
        }
      }

      const updateRequest: UpdateRoomCategoryRequest = {
        ...categoryData,
        price: parseFloat(price),
        ...(uploadedPhotoId && { photoId: uploadedPhotoId }),
      };

      await updateRoomCategoryMutation.mutateAsync(updateRequest);

      toast.success("Room category updated successfully!");
    } catch (err) {
      const message = (err as Error).message || "Update failed";
      setError(message);
      toast.error(message);
      console.error("Error updating category:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleRoomCategoryUpdate,
    isLoading,
    error,
  };
};
